import './assets/scss/main.scss'
import 'bootstrap';
import '@popperjs/core';
import jQuery from 'jquery';

// Make jQuery available globally for WebRotate360
window.jQuery = jQuery;
window.$ = jQuery;

// Load WebRotate360 script after jQuery is available
const script = document.createElement('script');
script.src = '/webrotate360/js/imagerotator.js';
script.async = false; // Ensure it loads before Vue components
document.head.appendChild(script);

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueSplide from '@splidejs/vue-splide'
import '@splidejs/vue-splide/css/core';

import Swal from 'sweetalert2';

import axiosPlugin from './plugins/axios'

const app = createApp(App);

import bus from './bus';

app.config.globalProperties.$bus = bus;

app.config.globalProperties.$swal = Swal;

axiosPlugin(router);  // Apply plugin to global axios instance

app.use(store);
app.use(VueSplide);

if (typeof window !== 'undefined' && !document.getElementById('hs-script-loader')) {
    const script = document.createElement('script')
    script.id = 'hs-script-loader'
    script.src = '//js-eu1.hs-scripts.com/145611921.js'
    script.async = true
    script.defer = true
    document.head.appendChild(script)
}

// Validate the cached session against the backend BEFORE the router renders the
// first route. This prevents the cached page flashing before the 401 redirect.
store.dispatch('account/initializeSession').finally(() => {
    app.use(router);
    app.mount('#app');
});
